import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	fetching: null,
};

export const GlobalSearch = createSlice({
	name: "globalSearch",
	initialState,
	reducers: {
		SET_FETCHING: (state, action) => {
			state.fetching = action.payload;
		},
	},
});

export const { actions } = GlobalSearch;
export default GlobalSearch.reducer;
